import type { LinkPreviewInfoProjectInfoEngagementAllOf } from './linkPreviewInfoProjectInfoEngagementAllOf';
import type { LinkPreviewInfoProjectInfoEngagementAllOfTwo } from './linkPreviewInfoProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type LinkPreviewInfoProjectInfoEngagement = LinkPreviewInfoProjectInfoEngagementAllOf & LinkPreviewInfoProjectInfoEngagementAllOfTwo;
